import LenderPageTemplate from '@/components/shared/LenderPageTemplate'

const MoneybarnPage = () => {
  return (
    <LenderPageTemplate
      lenderName="Moneybarn"
      slug="/lenders/mis-sold-moneybarn-car-finance"
      seoImage=""
      seoImageAlt=""
      aiOverview=""
    />
  )
}

export default MoneybarnPage
